import React from "react";
import ReactDOM from "react-dom";
import { Dapp2 } from "./components/Dapp";
import { ThemeProvider } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import { cryptobroadwayTheme } from "./theme";
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import { BrowserRouter as Router } from "react-router-dom";

Sentry.init({
  dsn: "https://a9e3b2c1d5324ad8b946d5fd74b3e240@o919812.ingest.sentry.io/5885147",
  integrations: [new Integrations.BrowserTracing()],
  environment: process.env.REACT_APP_NODE_ENV,
  tracesSampleRate: 0.5
});

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <ThemeProvider theme={cryptobroadwayTheme}>
        <CssBaseline />
        <Dapp2 />
      </ThemeProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
